<div class="btn-group pull-right" role="group"
  aria-label="Button group with nested dropdown">

  <button
    type="button"
    id="showSummary"
    class="ms-1"
    mat-stroked-button
    (click)="navigateToVoyageWithTimestamp(this.currentVoyageId)">
    Summary
  </button>

  <button
    type="button"
    id="previousVoyage"
    class="ms-1"
    mat-stroked-button
    (click)="navigateToVoyage(previousVoyageId)"
    [disabled]="previousVoyageId === ''">
    <i class="fa fa-caret-left me-1"></i>
    Previous voyage
  </button>

  <button
    type="button"
    id="nextVoyage"
    class="ms-1"
    mat-stroked-button
    (click)="navigateToVoyage(nextVoyageId)"
    [disabled]="nextVoyageId === ''">
    Next voyage
    <i class="fa fa-caret-right ms-1"></i>
  </button>

  <ng-container *appHideIfNotInRole="['vessels-voyages-editor']">
    <button
      class="dropdown-toggle ms-1"
      mat-stroked-button
      type="button"
      id="addButtonGroup"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      Add
    </button>

    <ul class="dropdown-menu" aria-labelledby="addButtonGroup">
      <li><a class="dropdown-item" (click)="showAddDocument('nor')">NOR</a></li>
      <li><a class="dropdown-item" (click)="showAddDocument('sof')">SOF</a></li>
      <li><a class="dropdown-item"
          (click)="showAddDocument('bl')">Bill Of Lading</a></li>
      <li><a class="dropdown-item"
          (click)="showAddDocument('discharge')">Discharge</a></li>
      <li><a class="dropdown-item"
          (click)="showAddDocument('comment')">Comment</a></li>
      <li><a class="dropdown-item"
          (click)="showAddDocument('misdoc')">Document</a></li>
      <li><a class="dropdown-item"
          (click)="showAddDocument('charterer')">Charterer</a></li>
    </ul>
  </ng-container>
</div>
